module.exports = __webpack_public_path__ + "assets/icon-nav-leads-journey-component.8b26fcc9.svg";